import i18n from '@services/i18n/i18n'

import { TraineeColumnType } from '../traineesDataGridColumns'

export const examDateColumnModel: TraineeColumnType = {
  field: 'examDate',
  width: 125,
  filterable: false,
  renderCell: (params) => {
    const date = new Date(params.value as string)

    return params.value
      ? date.toLocaleDateString(i18n.language, {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
      })
      : '-'
  }
}
